import { useMutation } from '@apollo/client';

import { CompanyBankAccountsDocument } from 'common/hooks/useCompanyBankAccounts/graphql/companyBankAccounts.gql';
import useCompanyContext from 'common/hooks/useCompanyContext';

import { CreateSecondaryBankAccountDocument } from '../graphql/mutations/createSecondaryBankAccount.gql';

const useCreateBankAccount = () => {
  const { companyProfileId } = useCompanyContext();

  if (!companyProfileId) {
    throw new Error('companyProfileId is undefined in useCreateBankAccount');
  }

  return useMutation(CreateSecondaryBankAccountDocument, {
    awaitRefetchQueries: true,
    refetchQueries: [
      { query: CompanyBankAccountsDocument, variables: { companyProfileId } },
    ],
  });
};

export default useCreateBankAccount;
